export const environment = {
    production: true,
    staging: false,
    gdev: false,
    fullSecureAuthentication: {
        true: {
            fullSecureAuthentication: true,
            redirectUrlAfterSignedOut: 'bma-dvs://redirect',
            signOutUri: 'bma-dvs://signout',
            callbackUri: 'bma-dvs://callback',
            loginUri: 'bma-dvs://signin',
        },
        false: {
            fullSecureAuthentication: false,
            callbackUri: '/callback',
            loginUri: '/login',
        },
    },
};

export const APP_MAIN = 'https://mbmatax.bangkok.go.th';
export const APP_FOLDER = '/verifytax';
export const APP_ASSETS = '/verifytax/assets';
export const PUBLIC_URL = `${APP_MAIN}${APP_FOLDER}`;
export const API_URL = 'https://mbmatax.bangkok.go.th/verifytax-gateway/api';
export const APP_WEBSITE_NAME = 'verifytax';
export const APP_LOGIN_URL = `https://bmatax.bangkok.go.th/auth/login?redirect_url=https://mbmatax.bangkok.go.th/${APP_WEBSITE_NAME}/callback`;
export const APP_LOGOUT_URL = `https://bmatax.bangkok.go.th/auth/logout?redirect_url=https://mbmatax.bangkok.go.th/${APP_WEBSITE_NAME}/callback`;
export const APP_PORTAL_VERIFY_URL = `https://bmatax.bangkok.go.th/auth/verify`;
export const API_URL_MAP =
    'https://mbmatax.bangkok.go.th/arcgis/rest/services/SurveyTaxMap/SurveyTaxView/MapServer';
export const APP_BMA_TAXMAP_URL_PREFIX = 'mbmatax.bangkok.go.th/arcgis';
export const APP_BMA_PROXY_URL =
    'https://mbmatax.bangkok.go.th/proxy/proxy.ashx';

export const APP_BMA_FEATURE_LAYER_URL =
    'https://mbmatax.bangkok.go.th/arcgis/rest/services/SurveyTaxMap/SurveyTaxView/MapServer';
export const APP_BMA_MAP_PROXY = true;

export const APP_BMA_FEATURE_LAYER_SIGNBOARD_FIELD_NAME = 'SIGN_GISID';
export const APP_BMA_FEATURE_LAYER_CONDO_FIELD_NAME = 'CONDO_ID';
export const APP_BMA_FEATURE_LAYER_BUILDING_FIELD_NAME = 'BLDG_ID';
export const APP_BMA_FEATURE_LAYER_LAND_FIELD_NAME = 'PK_LINK';
export const APP_BMA_FEATURE_LAYER_SIGNBOARD_ID = 2;
export const APP_BMA_FEATURE_LAYER_CONDO_ID = 3;
export const APP_BMA_FEATURE_LAYER_BUILDING_ID = 4;
export const APP_BMA_FEATURE_LAYER_LAND_ID = 6;

export const APP_BMA_FEATURE_LAYER_LAND_DRAFT = '7';
export const APP_BMA_FEATURE_LAYER_BUILDING_DRAFT = '5';
export const APP_BMA_FEATURE_LAYER_SIGN_DRAFT = '2';

export const APP_BMA_TOC_LAYER_URL = API_URL_MAP;

export const FCM_TOPIC = `th.go.bangkok.taxmap.verify_{userId}`;

export const API_PAYMENT_TOKEN =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjUxNTI5NjEsImlzcyI6Imh0dHBzOi8vYm1hdGF4LmJhbmdrb2suZ28udGgiLCJhdWQiOiJodHRwczovL2JtYXRheC5iYW5na29rLmdvLnRoIiwic3ViIjoiMzc5IiwiY2lkIjoiYm1hdGF4LXBvcnRhbCIsImlhdCI6MTY2NTExNjk2MSwibm9uY2UiOiI5ODY2OThkZjNjNWU0NDdmYmZkZWNhNDQ2OGEyNDU3MyJ9.ctV-46BVOk8B_QWVv4RVT7R4RH6xeRsEVFmQ6jMcLtk';

export const FUNCTION_ID_PDS3 = 'VR-06-01';
export const FUNCTION_ID_PDS4 = 'VR-06-02';
export const FUNCTION_ID_PDS6 = 'VR-06-03';
export const FUNCTION_ID_PDS7 = 'VR-06-04';
export const FUNCTION_ID_PDS8 = 'VR-06-05';
export const FUNCTION_ID_PP1 = 'VR-06-07';
export const FUNCTION_ID_PP2 = 'VR-06-08';

export const APP_BMA_QR_ANDROID = `${API_URL}/download/04_VR/QR-Code/VR-QR-Android.png`;
export const APP_BMA_QR_IOS = `${API_URL}/download/04_VR/QR-Code/VR-QR-iOS.png`;
export const APP_BMA_STORE_ANDROID = 'https://play.google.com/store/apps/details?id=th.go.bangkok.taxmap.verify.pub';
export const APP_BMA_STORE_IOS = 'https://apps.apple.com/app/id1644677970';